import OrderDetailsPage from 'feature/orders/details/order-details-page';

export default OrderDetailsPage;
